const React = require('react');
const { Typography, Button, List, ListItemText, ListItem, ListItemIcon } = require('@material-ui/core');
const { FontAwesomeIcon } = require('@fortawesome/react-fontawesome');
const { UserAvatarV2 } = require('./commonControls.jsx.js');
const { useState } = require('react');
const UserSearch = require('./userSearch.jsx').UserSearch;
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
   listItemText: {
      wordWrap:'break-word'
    },
 }));

export function MessageSideBar(props) {
   let [showUserPicker, setShowUserPicker] = useState(false);
   const classes = useStyles();

      let messages = props.overviewData.sort((a, b) =>
      new Date(b.privateMessage.sendTime) - new Date(a.privateMessage.sendTime)
   );
      return (
         <div>
            <h1 style={{ marginBottom: '10px' }}>Messages</h1>
            <Button variant='outlined' onClick={() => setShowUserPicker(!showUserPicker)}
               className="material-button" fullWidth> <FontAwesomeIcon icon={['far', showUserPicker?"times":"comment-alt-lines"]} transform="left-5" />{showUserPicker?'Cancel':'New Message'}</Button>
            {showUserPicker && <div style={{ marginTop: '10px' }}>
               <UserSearch
                  userBtnText={'Message'}
                  userBtnFunction={(idCorrespondent) => props.setCorrespondent(idCorrespondent)}
               />
            </div>
            }
            <List>
               {messages && messages.map((message, i) =>{
                  let badgeText = message.unreadCount ? message.unreadCount + '(New)' : '';
                  return(
                     <ListItem className="material-button" key={i} component={Button} onClick={() => {
                     props.setCorrespondent(message.user.id)
                     setShowUserPicker(false)
                  }}
                     style={{ textTransform: 'none' }}>
                     <ListItemIcon>
                        <UserAvatarV2 userData={message.user}></UserAvatarV2>
                     </ListItemIcon>
                     <ListItemText  classes={{ secondary: classes.listItemText }} primary={`${message.user.firstName} ${message.user.lastName} ${badgeText}` } secondary={message.privateMessage.message} />

                  </ListItem>)})}
            </List>
         </div>
      );
   
};

